import React, { useState, useEffect } from 'react';
import { crearPagoDLocalGo, crearPagoMultipleDLocalGo, verificarEstadoPagoDLocalGo, verificarEstadoPagoMultipleDLocalGo, obtenerFechasPago, verificarPagosAnterioresHistorial, obtenerTodosControlPagos } from '../../services/pagosServices';
import { CreditCard, FileText, Lock, Shield, Loader, Check, CheckCircle, RefreshCw,AlertCircle, ArrowLeft, X, ExternalLink } from 'lucide-react';
import { ToastContainer, toast } from 'react-toastify';
import { obtenerCentro, obtenerPlanes } from '../../services/centroService';
import { verificarHijos, obtenerMatriculaPorId, actualizarMatricula } from '../../services/matriculaService';
import 'react-toastify/dist/ReactToastify.css';



// Funciones de notificación estandarizadas
const showSuccessToast = (message) => {
    toast.success(message, {
        position: 'top-right',
        autoClose: 3000,
        style: { 
            marginTop: '10px',
            fontFamily: '"Exo 2", sans-serif',
            fontWeight: 500
        }
    });
};

const showErrorToast = (message) => {
    toast.error(message, {
        position: 'top-right',
        autoClose: 3000,
        style: { 
            marginTop: '10px',
            fontFamily: '"Exo 2", sans-serif',
            fontWeight: 500
        }
    });
};

const showWarningToast = (message) => {
    toast.warning(message, {
        position: 'top-right',
        autoClose: 3000,
        style: { 
            marginTop: '10px',
            fontFamily: '"Exo 2", sans-serif',
            fontWeight: 500
        }
    });
};

const PagoMultiple = ({ onSeleccionarNino }) => {
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');
    const [isProcessingDLocal, setIsProcessingDLocal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [amount, setAmount] = useState(0);
    const [hijos, setHijos] = useState([]);
    const [hijosSeleccionados, setHijosSeleccionados] = useState([]);
    const [tienePagosAnteriores, setTienePagosAnteriores] = useState(false);
    const [mostrarSeleccionPlan, setMostrarSeleccionPlan] = useState(false);
    const [planes, setPlanes] = useState([]);
    const [planSeleccionado, setPlanSeleccionado] = useState(null);
    const [planActual, setPlanActual] = useState(null);
    const [loadingPlanes, setLoadingPlanes] = useState(false);
    const [hijoEnSeleccion, setHijoEnSeleccion] = useState(null);
    const [vistaSeleccionPlan, setVistaSeleccionPlan] = useState(false);
    const [fechasPago, setFechasPago] = useState([]);
    const [pagoTarjetaPendiente, setPagoTarjetaPendiente] = useState(false);
    const [estadoPagoTarjeta, setEstadoPagoTarjeta] = useState('');
    const [linkPago, setLinkPago] = useState('');
    const [isVerificandoPago, setIsVerificandoPago] = useState(false);
    const [ultimoToastMostrado, setUltimoToastMostrado] = useState(0);
    const [pagosMultiplesPendientes, setPagosMultiplesPendientes] = useState([]);
    const [isVerificandoPagoMultiple, setIsVerificandoPagoMultiple] = useState({});

    // Función para verificar el estado de pago con tarjeta
    const verificarEstadoPagoTarjeta = async (paymentId) => {
        if (isVerificandoPago) return;
        
        setIsVerificandoPago(true);
        try {
            const response = await verificarEstadoPagoDLocalGo(paymentId);
            
            if (response.success) {
                if (response.status === 'PAID') {
                    console.log('Pago confirmado como PAID');
                    showSuccessToast('¡Pago confirmado exitosamente!');
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } else if (response.status === 'PENDING') {
                    console.log('Pago aún pendiente');
                    const ahora = Date.now();
                    if (ahora - ultimoToastMostrado > 5000) {
                        showWarningToast('El pago está pendiente de procesamiento o aún no lo ha realizado');
                        setUltimoToastMostrado(ahora);
                    }
                } else {
                    console.log('Estado del pago:', response.status);
                    showWarningToast(`Estado del pago: ${response.status}`);
                }
            } else {
                showErrorToast('Error al verificar el estado del pago');
            }
        } catch (error) {
            console.error('Error al verificar estado del pago:', error);
            showErrorToast('Error al verificar el estado del pago');
        } finally {
            setIsVerificandoPago(false);
        }
    };

    // Función para verificar el estado de pagos múltiples
    const verificarEstadoPagoMultiple = async (paymentId) => {
        if (isVerificandoPagoMultiple[paymentId]) return;
        
        setIsVerificandoPagoMultiple(prev => ({ ...prev, [paymentId]: true }));
        try {
            const response = await verificarEstadoPagoMultipleDLocalGo(paymentId);
            
            if (response.success) {
                if (response.payment?.status === 'PAID') {
                    console.log('Pago múltiple confirmado como PAID');
                    showSuccessToast('¡Pago múltiple confirmado exitosamente!');
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } else if (response.payment?.status === 'PENDING') {
                    console.log('Pago múltiple aún pendiente');
                    const ahora = Date.now();
                    if (ahora - ultimoToastMostrado > 5000) {
                        showWarningToast('El pago múltiple está pendiente de procesamiento o aún no lo ha realizado');
                        setUltimoToastMostrado(ahora);
                    }
                } else {
                    console.log('Estado del pago múltiple:', response.payment?.status);
                    showWarningToast(`Estado del pago múltiple: ${response.payment?.status}`);
                }
            } else {
                showErrorToast('Error al verificar el estado del pago múltiple');
            }
        } catch (error) {
            console.error('Error al verificar estado del pago múltiple:', error);
            showErrorToast('Error al verificar el estado del pago múltiple');
        } finally {
            setIsVerificandoPagoMultiple(prev => ({ ...prev, [paymentId]: false }));
        }
    };

    // Función para verificar el estado general de pagos
    const verificarEstadoPago = async (idMatricula) => {
        try {
            const response = await obtenerFechasPago(idMatricula);
            if (response.success && response.data) {
                setFechasPago(response.data);
                
                const ultimoRegistro = response.data && response.data.length > 0 ? response.data[response.data.length - 1] : null;
                
                if (ultimoRegistro) {
                    const tienePagoTarjetaPendiente = ultimoRegistro.metodo_pago === 'Tarjeta' && 
                                                   (ultimoRegistro.estado_pago === 'pendiente' || ultimoRegistro.estado_pago === 'en_proceso');
                    
                    setPagoTarjetaPendiente(tienePagoTarjetaPendiente);
                    
                    if (tienePagoTarjetaPendiente) {
                        setEstadoPagoTarjeta(ultimoRegistro.estado_pago);
                        setLinkPago(ultimoRegistro.link_pago || '');
                        
                        if (ultimoRegistro.payment_id && !isVerificandoPago) {
                            verificarEstadoPagoTarjeta(ultimoRegistro.payment_id);
                        }
                    }
                }
            }
        } catch (error) {
            console.error('Error al verificar estado de pago:', error);
        }
    };

    // Función para verificar pagos anteriores
    const verificarPagosAnteriores = async (idMatricula) => {
        try {
            console.log('Verificando pagos anteriores para matrícula:', idMatricula);
            const response = await verificarPagosAnterioresHistorial(idMatricula);
            console.log('Respuesta de verificación de historial:', response);
            
            if (response.success && response.tienePagosAnteriores) {
                console.log('Tiene pagos anteriores en historial - mostrando selección de plan');
                setTienePagosAnteriores(true);
                // Para obtener el monto, necesitamos consultar las fechas de pago
                const fechasResponse = await obtenerFechasPago(idMatricula);
                let montoActual = 0;
                if (fechasResponse.data && fechasResponse.data.length > 0) {
                    const ultimoPago = fechasResponse.data[fechasResponse.data.length - 1];
                    montoActual = Number(ultimoPago.monto) || 0;
                }
                return {
                    tienePagos: true,
                    montoActual: montoActual
                };
            } else {
                console.log('NO tiene pagos anteriores en historial - primera vez pagando');
                setTienePagosAnteriores(false);
                return {
                    tienePagos: false,
                    montoActual: 0
                };
            }
        } catch (error) {
            console.error('Error al verificar pagos anteriores:', error);
            // En caso de error, asumimos que es primera vez
            setTienePagosAnteriores(false);
            return {
                tienePagos: false,
                montoActual: 0
            };
        }
    };

    // Función para cargar planes para un hijo específico
    const cargarPlanesParaHijo = async (hijo, montoActual = null) => {
        try {
            setLoadingPlanes(true);
            const response = await obtenerPlanes();
            if (response.success) {
                setPlanes(response.data);
                
                let planActualEncontrado = null;
                
                // Si tenemos el monto actual, buscar el plan que coincida con ese monto
                if (montoActual && montoActual > 0) {
                    planActualEncontrado = response.data.find(plan => 
                        Number(plan.monto) === montoActual
                    );
                }
                
                // Si no se encontró por monto, buscar por id_plan del hijo
                if (!planActualEncontrado) {
                    planActualEncontrado = response.data.find(plan => 
                        plan.id_plan === hijo.id_plan
                    );
                }
                
                setPlanActual(planActualEncontrado || null);
                setPlanSeleccionado(planActualEncontrado || null);
                
                // NO establecer el monto del plan actual aquí - solo cuando se confirme
                if (planActualEncontrado) {
                    // setAmount(Number(planActualEncontrado.monto) || 0);
                    // Guardar temporalmente el plan seleccionado para la vista superpuesta
                    localStorage.setItem('planSeleccionadoTemp', JSON.stringify(planActualEncontrado));
                }
            }
        } catch (error) {
            console.error('Error al cargar planes:', error);
            showErrorToast('Error al cargar los planes disponibles');
        } finally {
            setLoadingPlanes(false);
        }
    };

    // Función para renderizar la descripción con beneficios como viñetas
    const renderDescripcion = (descripcion) => {
        if (!descripcion) return null;
        
        const partes = descripcion.split(';');
        
        if (partes.length <= 1) {
            return <p className="text-sm text-gray-600">{descripcion}</p>;
        }
        
        const descripcionBase = partes[0].trim();
        const beneficios = partes.slice(1).filter(beneficio => beneficio.trim());
        
        return (
            <div>
                {descripcionBase && (
                    <p className="text-sm text-gray-600 mb-3">{descripcionBase}</p>
                )}
                {beneficios.length > 0 && (
                    <div>
                        <p className="font-semibold text-gray-700 mb-2 text-sm">Incluye:</p>
                        <ul className="list-disc list-inside space-y-1 text-gray-600 ml-2">
                            {beneficios.map((beneficio, index) => (
                                <li key={index} className="text-sm leading-relaxed">
                                    {beneficio.trim()}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    };

    // Función para manejar la selección de un plan
    const handleSeleccionarPlan = (plan, e) => {
        // Prevenir comportamiento por defecto para evitar recarga de página
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        if (e && e.stopPropagation) {
            e.stopPropagation();
        }
        setPlanSeleccionado(plan);
        // NO actualizar el monto aquí - solo cuando se confirme el plan
        // setAmount(plan.monto);
    };

    // Función para confirmar el cambio de plan
    const confirmarCambioPlan = (e) => {
        // Prevenir comportamiento por defecto para evitar recarga de página
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        
        if (planSeleccionado) {
            try {
                // Guardar el plan seleccionado en localStorage para uso posterior
                localStorage.setItem('planSeleccionado', JSON.stringify(planSeleccionado));
                
                // Obtener el hijo seleccionado del localStorage si existe
                const hijoSeleccionadoTemp = JSON.parse(localStorage.getItem('hijoSeleccionadoTemp'));
                
                if (hijoSeleccionadoTemp) {
                    // Actualizar el monto del hijo con el plan seleccionado
                    const hijoActualizado = {
                        ...hijoSeleccionadoTemp,
                        plan_monto: planSeleccionado.monto
                    };
                    
                    // Agregar el hijo a la selección
                    const nuevosSeleccionados = [...hijosSeleccionados, hijoActualizado];
                    setHijosSeleccionados(nuevosSeleccionados);
                    
                    // Recalcular el monto total
                    const nuevoMonto = nuevosSeleccionados.reduce((total, h) => {
                        return total + (Number(h.plan_monto) || 0);
                    }, 0);
                    setAmount(nuevoMonto);
                    
                    // Limpiar el localStorage temporal
                    localStorage.removeItem('hijoSeleccionadoTemp');
                }
                
                // Cambiar el estado después de que todo se haya procesado correctamente
                setMostrarSeleccionPlan(false);
                
                if (planSeleccionado.id !== planActual?.id) {
                    showSuccessToast(`Plan cambiado a: ${planSeleccionado.nombre}`);
                } else {
                    showSuccessToast(`Plan renovado: ${planSeleccionado.nombre}`);
                }
            } catch (error) {
                console.error('Error al confirmar cambio de plan:', error);
                showErrorToast('Error al confirmar el plan seleccionado');
            }
        }
    };
    
    // Función para cancelar la selección de plan
    const cancelarSeleccionPlan = (e) => {
        // Prevenir comportamiento por defecto para evitar recarga de página
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        
        try {
            // Limpiar el localStorage temporal sin agregar el hijo a la selección
            localStorage.removeItem('hijoSeleccionadoTemp');
            
            // Cambiar el estado después de que todo se haya procesado correctamente
            setMostrarSeleccionPlan(false);
        } catch (error) {
            console.error('Error al cancelar selección de plan:', error);
            showErrorToast('Error al cancelar la selección del plan');
        }
    };

    // Funciones para la nueva vista superpuesta
    const handleSeleccionarPlanVista = (e, plan) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        if (e && e.stopPropagation) {
            e.stopPropagation();
        }
        
        setPlanSeleccionado(plan);
        // Actualizar el monto cuando se selecciona un plan diferente
        setAmount(Number(plan.monto) || 0);
        // Guardar temporalmente en localStorage
        localStorage.setItem('planSeleccionadoTemp', JSON.stringify(plan));
    };

    const confirmarPlanVista = async (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        if (!planSeleccionado || !hijoEnSeleccion) {
            showErrorToast('Por favor, seleccione un plan');
            return;
        }

        try {
            // Actualizar el plan del hijo si es diferente al actual
            if (planSeleccionado.id !== planActual?.id) {
                const hijoActualizado = {
                    ...hijoEnSeleccion,
                    plan_id: planSeleccionado.id,
                    plan_nombre: planSeleccionado.nombre,
                    plan_monto: planSeleccionado.monto
                };

                await actualizarMatricula(hijoEnSeleccion.id_matricula, {
                    plan_id: planSeleccionado.id
                });

                // Agregar el hijo actualizado a la selección
                const nuevosSeleccionados = [...hijosSeleccionados, hijoActualizado];
                setHijosSeleccionados(nuevosSeleccionados);

                // Recalcular el monto total
                const montoTotal = nuevosSeleccionados.reduce((total, h) => {
                    return total + (Number(h.plan_monto) || 0);
                }, 0);
                setAmount(montoTotal);
            } else {
                // Si es el mismo plan, agregar directamente
                const nuevosSeleccionados = [...hijosSeleccionados, hijoEnSeleccion];
                setHijosSeleccionados(nuevosSeleccionados);

                const montoTotal = nuevosSeleccionados.reduce((total, h) => {
                    return total + (Number(h.plan_monto) || 0);
                }, 0);
                setAmount(montoTotal);
            }

            // Guardar información del plan en localStorage
            localStorage.setItem('planConfirmado', JSON.stringify({
                planSeleccionado,
                planActual,
                hijoId: hijoEnSeleccion.id_matricula
            }));

            // Cerrar la vista de selección
            setVistaSeleccionPlan(false);
            setHijoEnSeleccion(null);
            setPlanSeleccionado(null);
            setPlanActual(null);

            // Limpiar localStorage temporal
            localStorage.removeItem('planSeleccionadoTemp');

            if (planSeleccionado.id !== planActual?.id) {
                showSuccessToast(`Plan cambiado a: ${planSeleccionado.nombre}`);
            } else {
                showSuccessToast(`Plan renovado: ${planSeleccionado.nombre}`);
            }
        } catch (error) {
            console.error('Error al confirmar plan:', error);
            showErrorToast('Error al confirmar el plan seleccionado');
        }
    };

    const cancelarSeleccionPlanVista = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        // Limpiar estados temporales
        setVistaSeleccionPlan(false);
        setHijoEnSeleccion(null);
        setPlanSeleccionado(null);
        setPlanActual(null);
        localStorage.removeItem('planSeleccionadoTemp');
    };

    // Función para obtener y agrupar pagos múltiples pendientes
    const obtenerPagosMultiplesPendientes = async (hijosActualizados = null) => {
        try {
            const controlPagos = await obtenerTodosControlPagos();
            
     console.log('Control de pagos obtenidos:', controlPagos);
            
            if (!controlPagos || !controlPagos.data || !Array.isArray(controlPagos.data)) {
                console.warn('No se pudieron obtener controles de pago para verificar pagos múltiples');
                return;
            }
            
            console.log('Total de registros de control de pagos:', controlPagos.data.length);
            
            // Debug: Verificar todos los registros
            controlPagos.data.forEach((pago, index) => {
                console.log(`Registro ${index}:`, {
                    id_control: pago.id_control,
                    tipo_pago: pago.tipo_pago,
                    estado_verificacion: pago.estado_verificacion,
                    payment_id: pago.payment_id,
                    id_matricula: pago.id_matricula
                });
            });
            
            // Filtrar pagos múltiples pendientes con tarjeta (cualquier pago con payment_id es múltiple)
            const pagosMultiples = controlPagos.data.filter(
                pago => pago.tipo_pago === 'Tarjeta' && 
                       pago.estado_verificacion === 'Pendiente' &&
                       pago.payment_id && pago.payment_id.trim() !== ''
            );
            
            console.log('Pagos múltiples filtrados:', pagosMultiples);
            console.log('Cantidad de pagos múltiples encontrados:', pagosMultiples.length);
            
            // Agrupar por payment_id e incluir nombres de hijos
            const pagosAgrupados = {};
            for (const pago of pagosMultiples) {
                console.log('Procesando pago:', pago);
                if (!pagosAgrupados[pago.payment_id]) {
                    pagosAgrupados[pago.payment_id] = {
                        payment_id: pago.payment_id,
                        comprobante_pago: pago.comprobante_pago,
                        fecha_pago: pago.proxima_fecha_pago || pago.fecha_pago, // Usar proxima_fecha_pago para pagos pendientes
                        pagos: [],
                        total: 0,
                        hijos: [] // Array para almacenar nombres de hijos
                    };
                }
                
                // Buscar el nombre del hijo correspondiente a esta matrícula
                const hijosParaBuscar = hijosActualizados || hijos;
                const hijoEncontrado = hijosParaBuscar?.find(hijo => hijo.id_matricula === pago.id_matricula);
                const nombreHijo = hijoEncontrado ? hijoEncontrado.nombre : `Matrícula #${pago.id_matricula}`;
                
                pagosAgrupados[pago.payment_id].pagos.push(pago);
                pagosAgrupados[pago.payment_id].hijos.push(nombreHijo);
                pagosAgrupados[pago.payment_id].total += parseFloat(pago.monto || 0);
            }
            
            console.log('Pagos agrupados:', pagosAgrupados);
            
            // Convertir a array y verificar automáticamente cada pago múltiple
            const pagosArray = Object.values(pagosAgrupados);
            console.log('Array de pagos múltiples para establecer en estado:', pagosArray);
            setPagosMultiplesPendientes(pagosArray);
            
            // Verificar automáticamente el estado de cada pago múltiple
            for (const pagoGrupo of pagosArray) {
                if (!isVerificandoPagoMultiple[pagoGrupo.payment_id]) {
                    setTimeout(() => {
                        verificarEstadoPagoMultiple(pagoGrupo.payment_id);
                    }, 1000); // Pequeño delay para evitar múltiples peticiones simultáneas
                }
            }
            
        } catch (error) {
            console.error('Error al obtener pagos múltiples pendientes:', error);
        }
    };

    useEffect(() => {
        const obtenerDatos = async () => {
            try {
                // Obtener hijos del padre
                const padreId = JSON.parse(localStorage.getItem('user'))?.id;
                if (padreId) {
                    const responseHijos = await verificarHijos(padreId);
                    if (responseHijos.hijos) {
                        // Filtrar solo hijos con matrícula activa
                        const hijosActivos = responseHijos.hijos.filter(hijo => hijo.estado_matricula === 'Activa');
                        const hijosConPago = await Promise.all(
                            hijosActivos.map(async (hijo) => {
                                try {
                                    const fechasResponse = await obtenerFechasPago(hijo.id_matricula);
                                    const fechaActual = new Date();
                                    fechaActual.setHours(0, 0, 0, 0);
                                    const ultimoRegistro = fechasResponse.data && fechasResponse.data.length > 0 
                                        ? fechasResponse.data[fechasResponse.data.length - 1] 
                                        : null;
                                    const proximaFechaPago = ultimoRegistro ? new Date(ultimoRegistro.proxima_fecha_pago) : null;
                                    if (proximaFechaPago) {
                                        proximaFechaPago.setHours(0, 0, 0, 0);
                                    }
                                    
                                    let requierePago = proximaFechaPago ? fechaActual >= proximaFechaPago : true;
                                    let pagoTarjetaPendiente = false;
                                    let transferenciaPendiente = false;
                                    
                                    // Usar la misma lógica que pagos.js - verificar el último registro
                                    if (ultimoRegistro && ultimoRegistro.estado_verificacion === 'Pendiente') {
                                        // Verificar si es una transferencia pendiente de verificación
                                        const tieneTransferenciaPendiente = ultimoRegistro.tipo_pago === 'Transferencia';
                                        
                                        // Verificar si es un pago con tarjeta pendiente
                                        const tienePagoTarjetaPendiente = ultimoRegistro.tipo_pago === 'Tarjeta';
                                        
                                        if (tieneTransferenciaPendiente) {
                                            transferenciaPendiente = true;
                                            pagoTarjetaPendiente = false;
                                            requierePago = false; // No requiere pago si hay transferencia en revisión
                                        } else if (tienePagoTarjetaPendiente) {
                                            pagoTarjetaPendiente = true;
                                            transferenciaPendiente = false;
                                            requierePago = false; // No requiere pago si hay tarjeta en validación
                                        }
                                    }
                                    
                                    // Verificar estado de verificación del último registro
                                    if (ultimoRegistro) {
                                        if (ultimoRegistro.estado_verificacion === 'Rechazado') {
                                            requierePago = true; // Siempre requiere pago si fue rechazado
                                            pagoTarjetaPendiente = false;
                                            transferenciaPendiente = false;
                                        } else if (ultimoRegistro.estado_verificacion === 'Verificado' || ultimoRegistro.estado === 'Completado') {
                                            requierePago = proximaFechaPago ? fechaActual >= proximaFechaPago : false;
                                            pagoTarjetaPendiente = false;
                                            transferenciaPendiente = false;
                                        } else {
                                            requierePago = proximaFechaPago ? fechaActual >= proximaFechaPago : true;
                                        }
                                    }
                                    
                                    return {
                                        ...hijo,
                                        requierePago,
                                        pagoTarjetaPendiente,
                                        transferenciaPendiente
                                    };
                                } catch (fechaError) {
                                    console.warn(`Error al obtener fechas para matrícula ${hijo.id_matricula}:`, fechaError);
                                    // Si hay error obteniendo fechas, asumimos que requiere pago
                                    return {
                                        ...hijo,
                                        requierePago: true
                                    };
                                }
                            })
                        );
                        
                        // Verificar transferencias pendientes para cada hijo
                        const hijosConPendientes = await Promise.all(
                            hijosConPago.map(async (hijo) => {
                                try {
                                    const controlPagos = await obtenerTodosControlPagos();
                                    
                                    // Verificar que la respuesta tenga la estructura esperada
                                    if (!controlPagos || !controlPagos.data || !Array.isArray(controlPagos.data)) {
                                        console.warn(`No se pudieron obtener controles de pago para verificar ${hijo.id_matricula}`);
                                        return {
                                            ...hijo,
                                            tienePendiente: false
                                        };
                                    }
                                    
                                    const tienePendiente = controlPagos.data.some(
                                        pago => pago.tipo_pago === 'Transferencia' && 
                                               pago.estado === 'Pendiente' &&
                                               pago.estado_verificacion === 'Pendiente' && // Solo transferencias en revisión
                                               pago.id_matricula === hijo.id_matricula
                                    );
                                    return {
                                        ...hijo,
                                        tienePendiente
                                    };
                                } catch (error) {
                                    console.warn(`Error al verificar pagos pendientes para ${hijo.id_matricula}:`, error.message || error);
                                    return {
                                        ...hijo,
                                        tienePendiente: false
                                    };
                                }
                            })
                        );
                        
                        setHijos(hijosConPendientes);
                        
                        // Obtener y agrupar pagos múltiples pendientes por payment_id
                        await obtenerPagosMultiplesPendientes(hijosConPendientes);
                        
                        // No mostrar selección de plan hasta que se seleccione un hijo
                        setMostrarSeleccionPlan(false);
                        
                        // Obtener el precio del plan desde el primer hijo activo
                        if (hijosActivos.length > 0) {
                            const primerHijo = hijosActivos[0];

                            
                            if (primerHijo.plan_monto) {
                                const precio = Number(primerHijo.plan_monto);
                                setAmount(isNaN(precio) ? 0 : precio);

                            } else {
                                console.warn('No se encontró plan_monto en el hijo. Datos disponibles:', {
                                    plan_monto: primerHijo.plan_monto,
                                    plan_nombre: primerHijo.plan_nombre,
                                    plan_tipo: primerHijo.plan_tipo
                                });
                                setAmount(0);
                            }
                        } else {
                            console.warn('No hay hijos activos disponibles');
                            setAmount(0);
                        }
                    } else {
                        setAmount(0);
                    }
                } else {
                    setAmount(0);
                }
                
                // Verificar si el usuario regresa de dLocal Go
                const returningFromDLocal = sessionStorage.getItem('returning_from_dlocal_multiple');
                if (returningFromDLocal) {
                    // Limpiar el marcador
                    sessionStorage.removeItem('returning_from_dlocal_multiple');
                    
                    // Limpiar la URL de parámetros de dLocal Go si existen
                    const url = new URL(window.location);
                    if (url.searchParams.has('payment_id') || url.searchParams.has('status')) {
                        url.search = '';
                        window.history.replaceState({}, '', url);
                    }
                    
                    // Esperar un momento y verificar el estado del pago
                    setTimeout(async () => {
                        try {
                            // Obtener pagos múltiples pendientes para verificar el último payment_id
                            // Usar hijos del estado ya que hijosConPago no está disponible en este scope
                            const hijosActuales = JSON.parse(localStorage.getItem('user'))?.id ? 
                                await verificarHijos(JSON.parse(localStorage.getItem('user')).id) : null;
                            
                            if (hijosActuales?.hijos) {
                                await obtenerPagosMultiplesPendientes(hijosActuales.hijos);
                                
                                // Si hay pagos múltiples pendientes, verificar el más reciente
                                if (Object.keys(pagosMultiplesPendientes).length > 0) {
                                    const paymentIds = Object.keys(pagosMultiplesPendientes);
                                    const ultimoPaymentId = paymentIds[paymentIds.length - 1];
                                    await verificarEstadoPagoMultiple(ultimoPaymentId);
                                }
                            }
                        } catch (error) {
                            console.error('Error al verificar pago después del regreso de dLocal Go:', error);
                        }
                    }, 2000);
                }
                
                // Verificar estado de pagos pendientes
                await verificarEstadoPago();
                
            } catch (err) {
                console.error('Error al obtener datos:', err);
                setError('Error al obtener información necesaria');
                setAmount(0);
            } finally {
                setIsLoading(false);
            }
        };

        obtenerDatos();
    }, []);
    
    // Escuchar eventos del controlador padre
    useEffect(() => {
        const manejarPlanConfirmado = (event) => {
            const { plan, planActual: planActualEvento } = event.detail;
            
            // Obtener el hijo seleccionado del localStorage si existe
            const hijoSeleccionadoTemp = JSON.parse(localStorage.getItem('hijoSeleccionadoTemp'));
            
            if (hijoSeleccionadoTemp) {
                // Actualizar el monto del hijo con el plan seleccionado
                const hijoActualizado = {
                    ...hijoSeleccionadoTemp,
                    plan_monto: plan.monto
                };
                
                // Agregar el hijo a la selección
                const nuevosSeleccionados = [...hijosSeleccionados, hijoActualizado];
                setHijosSeleccionados(nuevosSeleccionados);
                
                // Recalcular el monto total
                const nuevoMonto = nuevosSeleccionados.reduce((total, h) => {
                    return total + (Number(h.plan_monto) || 0);
                }, 0);
                setAmount(nuevoMonto);
                
                // Limpiar el localStorage temporal
                localStorage.removeItem('hijoSeleccionadoTemp');
                
                // Mostrar mensaje de éxito
                if (plan.id_plan !== planActualEvento?.id_plan) {
                    showSuccessToast(`Plan cambiado a: ${plan.nombre}`);
                } else {
                    showSuccessToast(`Plan renovado: ${plan.nombre}`);
                }
            }
        };
        
        const manejarPlanCancelado = () => {
            // Limpiar el localStorage temporal sin agregar el hijo a la selección
            localStorage.removeItem('hijoSeleccionadoTemp');
        };
        
        // Agregar event listeners
        window.addEventListener('planConfirmado', manejarPlanConfirmado);
        window.addEventListener('planCancelado', manejarPlanCancelado);
        
        // Cleanup
        return () => {
            window.removeEventListener('planConfirmado', manejarPlanConfirmado);
            window.removeEventListener('planCancelado', manejarPlanCancelado);
        };
    }, [hijosSeleccionados]);

    const toggleHijoSeleccionado = async (hijo) => {
        // Prevenir selección si tiene transferencia pendiente o pago por tarjeta pendiente
        if (hijo.transferenciaPendiente || hijo.pagoTarjetaPendiente) {
            return;
        }
        
        const yaSeleccionado = hijosSeleccionados.find(h => h.id_matricula === hijo.id_matricula);
        
        if (yaSeleccionado) {
            // Deseleccionar hijo
            const nuevosSeleccionados = hijosSeleccionados.filter(h => h.id_matricula !== hijo.id_matricula);
            setHijosSeleccionados(nuevosSeleccionados);
            
            // Si no quedan hijos seleccionados, ocultar vista de selección de plan
             if (nuevosSeleccionados.length === 0) {
                 setVistaSeleccionPlan(false);
                 setHijoEnSeleccion(null);
                 setPlanSeleccionado(null);
                 setPlanActual(null);
                 setAmount(0);
             } else {
                 // Recalcular el monto total con los hijos restantes
                 const montoTotal = nuevosSeleccionados.reduce((total, h) => {
                     return total + (Number(h.plan_monto) || 0);
                 }, 0);
                 setAmount(montoTotal);
             }
        } else {
            // Verificar si tiene pagos anteriores
            const resultadoPagos = await verificarPagosAnteriores(hijo.id_matricula);
            
            if (resultadoPagos.tienePagos) {
                // Mostrar vista de selección de plan superpuesta
                setHijoEnSeleccion(hijo);
                setVistaSeleccionPlan(true);
                await cargarPlanesParaHijo(hijo, resultadoPagos.montoActual);
            } else {
                // Si no tiene pagos anteriores, agregar directamente
                const nuevosSeleccionados = [...hijosSeleccionados, hijo];
                setHijosSeleccionados(nuevosSeleccionados);
                const montoTotal = nuevosSeleccionados.reduce((total, h) => {
                    return total + (Number(h.plan_monto) || 0);
                }, 0);
                setAmount(montoTotal);
            }
        }
    };

    // Función para manejar pago con dLocal Go para múltiples hijos
    const handleDLocalGoPagoMultiple = async (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        
        setError('');
        setIsProcessingDLocal(true);

        if (hijosSeleccionados.length === 0) {
            setError('Por favor, seleccione al menos un hijo para realizar el pago');
            setIsProcessingDLocal(false);
            return;
        }

        try {
            // Obtener las matrículas de los hijos seleccionados
            const matriculas = hijosSeleccionados.map(hijo => hijo.id_matricula);
            
            console.log('Creando pago múltiple para matrículas:', matriculas);
            
            // Crear un solo pago múltiple
            const response = await crearPagoMultipleDLocalGo(matriculas);
            
            if (response.success && response.redirect_url) {
                console.log('Respuesta del pago múltiple:', response);
                
                // Marcar que el usuario está yendo a dLocal Go para detectar el regreso
                sessionStorage.setItem('returning_from_dlocal_multiple', 'true');
                // Redirigir directamente en la misma ventana sin mostrar mensaje de éxito
                // dLocal Go se encargará de redirigir de vuelta al sistema después del pago
                window.location.href = response.redirect_url;
            } else {
                throw new Error('Error al crear el pago múltiple');
            }
            
        } catch (err) {
            console.error('Error en pago múltiple:', err);
            setError(err.message);
            showErrorToast(err.message);
        } finally {
            setIsProcessingDLocal(false);
        }
    };

    if (isLoading) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center p-4">
                <Loader className="w-8 h-8 animate-spin text-blue-600 mb-4" />
                <p className="text-gray-600">Cargando información de pagos...</p>
            </div>
        );
    }

    if (amount === 0 && hijosSeleccionados.length > 0) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center p-4">
                <p className="text-red-600 font-semibold">No se pudo obtener el valor de la mensualidad. Contacte a soporte.</p>
            </div>
        );
    }

    // Calcular el monto total sumando los montos individuales de cada hijo seleccionado
    const totalAmount = hijosSeleccionados.reduce((total, hijo) => {
        return total + (Number(hijo.plan_monto) || 0);
    }, 0);

    return (
        <div className="min-h-screen p-2 sm:p-4">
            <ToastContainer />
            
            {/* Vista Superpuesta de Selección de Plan */}
            {vistaSeleccionPlan && hijoEnSeleccion && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            <div className="text-center mb-6">
                                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                                    Seleccionar Plan para {hijoEnSeleccion.nombre}
                                </h2>
                                <p className="text-gray-600">Elige el plan que deseas renovar o cambiar</p>
                            </div>
                            
                            {loadingPlanes ? (
                                <div className="flex justify-center items-center py-8">
                                    <RefreshCw className="w-6 h-6 animate-spin text-blue-600" />
                                    <span className="ml-2 text-gray-600">Cargando planes...</span>
                                </div>
                            ) : (
                                <>
                                    {/* Lista de Planes Disponibles */}
                                    <div className="space-y-4 mb-6">
                                        <h3 className="text-lg font-semibold text-gray-800">Selecciona tu Plan</h3>
                                        {planes && planes.length > 0 ? planes.map((plan) => (
                                            <div 
                                                key={plan.id_plan} 
                                                onClick={(e) => handleSeleccionarPlanVista(e, plan)}
                                                className={`border rounded-lg p-4 cursor-pointer transition-all hover:shadow-md ${
                                                    planSeleccionado && plan.id_plan === planSeleccionado.id_plan
                                                        ? 'border-blue-500 bg-blue-50'
                                                        : 'border-gray-200 hover:border-blue-300'
                                                }`}
                                            >
                                                <div className="flex justify-between items-start mb-2">
                                                    <h4 className="font-semibold text-gray-900">
                                                        {plan.nombre}
                                                        {planActual?.id_plan === plan.id_plan && (
                                                            <span className="ml-2 bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                                                                Plan Actual
                                                            </span>
                                                        )}
                                                    </h4>
                                                    <span className="text-gray-700 font-bold">${plan.monto}/mes</span>
                                                </div>
                                                {plan.descripcion && (
                                                <div className="text-gray-600 text-sm mb-3">
                                                    {renderDescripcion(plan.descripcion)}
                                                </div>
                                            )}
                                                {planSeleccionado && plan.id_plan === planSeleccionado.id_plan && (
                                                    <div className="flex items-center text-blue-600 text-sm font-medium">
                                                        <Check className="w-4 h-4 mr-1" />
                                                        Seleccionado
                                                    </div>
                                                )}
                                            </div>
                                        )) : (
                                            <div className="text-center py-4 text-gray-500">
                                                <p>No hay planes disponibles</p>
                                            </div>
                                        )}
                                    </div>
                                    
                                    {/* Botones de Acción */}
                                    <div className="flex gap-3">
                                        <button
                                            onClick={cancelarSeleccionPlanVista}
                                            className="flex-1 py-3 px-4 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300 transition-colors font-medium"
                                        >
                                            Cancelar
                                        </button>
                                        <button
                                            onClick={confirmarPlanVista}
                                            disabled={!planSeleccionado}
                                            className={`flex-1 py-3 px-4 rounded-lg font-medium transition-colors ${
                                                planSeleccionado
                                                    ? 'bg-blue-600 text-white hover:bg-blue-700'
                                                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                            }`}
                                        >
                                            {planActual && planSeleccionado && planSeleccionado.id_plan !== planActual.id_plan 
                                                ? 'Cambiar Plan' 
                                                : 'Renovar Plan'
                                            }
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
            
            <div className="max-w-4xl mx-auto space-y-4 sm:space-y-6">
                <div className="text-center space-y-2">
                    <h2 className="text-xl sm:text-3xl font-bold text-gray-900">Pago múltiple de mensualidades</h2>
                    <p className="text-xs sm:text-sm text-gray-500">Seleccione los hijos para los que desea realizar el pago</p>
                </div>

                {/* Sección de Pagos Múltiples Pendientes */}
                {pagosMultiplesPendientes.length > 0 && (
                    <div className="backdrop-blur-md bg-white/30 rounded-lg sm:rounded-2xl shadow-xl border border-white/50 p-3 sm:p-6">
                        <div className="mb-4">
                            <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                                <AlertCircle className="w-5 h-5 text-orange-600" />
                                Pagos Múltiples Pendientes
                            </h3>
                            <p className="text-sm text-gray-600">
                                Tienes pagos múltiples pendientes de verificación. Puedes acceder al link de pago o verificar manualmente su estado.
                            </p>
                        </div>
                        
                        <div className="space-y-4">
                            {pagosMultiplesPendientes.map((pagoGrupo) => (
                                <div key={pagoGrupo.payment_id} className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                                        <div className="flex-1">
                                            <div className="flex items-center gap-2 mb-2">
                                                <CreditCard className="w-4 h-4 text-yellow-600" />
                                                <span className="font-medium text-yellow-800">
                                                    Pago Múltiple #{pagoGrupo.payment_id}
                                                </span>
                                            </div>
                                            <div className="text-sm text-yellow-700 space-y-1">
                                                <p><strong>Total:</strong> ${pagoGrupo.total.toFixed(2)} USD</p>
                                                <p><strong>Hijos incluidos:</strong> {pagoGrupo.pagos.length}</p>
                                                <p><strong>Período a pagar:</strong> {new Date(pagoGrupo.fecha_pago).toLocaleDateString()} - {(() => {
                                                    const fechaInicio = new Date(pagoGrupo.fecha_pago);
                                                    const fechaFin = new Date(fechaInicio);
                                                    fechaFin.setMonth(fechaFin.getMonth() + 1);
                                                    return fechaFin.toLocaleDateString();
                                                })()}</p>
                                                <div className="text-xs text-blue-600 mt-2">
                                    <strong>Hijos:</strong> {pagoGrupo.hijos.join(', ')}
                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="flex flex-col sm:flex-row gap-2">
                                            {pagoGrupo.comprobante_pago && (
                                                <a
                                                    href={pagoGrupo.comprobante_pago}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="flex items-center justify-center gap-2 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
                                                >
                                                    <ExternalLink className="w-4 h-4" />
                                                    Acceder al Pago
                                                </a>
                                            )}
                                            <button
                                                onClick={() => verificarEstadoPagoMultiple(pagoGrupo.payment_id)}
                                                disabled={isVerificandoPagoMultiple[pagoGrupo.payment_id]}
                                                className={`flex items-center justify-center gap-2 px-3 py-2 rounded-lg transition-colors text-sm ${
                                                    isVerificandoPagoMultiple[pagoGrupo.payment_id]
                                                        ? 'bg-gray-400 cursor-not-allowed text-white'
                                                        : 'bg-green-600 hover:bg-green-700 text-white'
                                                }`}
                                            >
                                                <RefreshCw className={`w-4 h-4 ${
                                                    isVerificandoPagoMultiple[pagoGrupo.payment_id] ? 'animate-spin' : ''
                                                }`} />
                                                {isVerificandoPagoMultiple[pagoGrupo.payment_id] ? 'Verificando...' : 'Verificar Estado'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4 mb-4 sm:mb-6">
                    {hijos && hijos.length > 0 ? hijos.filter((hijo) => {
                        // Filtrar hijos que ya están en pagos múltiples pendientes
                        const estaEnPagoMultiple = pagosMultiplesPendientes.some(pagoGrupo => 
                            pagoGrupo.pagos.some(pago => pago.id_matricula === hijo.id_matricula)
                        );
                        return !estaEnPagoMultiple;
                    }).map((hijo) => (
                        <div 
                            key={hijo.id_matricula}
                            onClick={() => hijo.requierePago && !hijo.transferenciaPendiente && !hijo.pagoTarjetaPendiente && toggleHijoSeleccionado(hijo)}
            className={`
                p-2 sm:p-4 rounded-lg sm:rounded-xl border transition-all duration-200 cursor-pointer
                ${hijo.requierePago && !hijo.transferenciaPendiente && !hijo.pagoTarjetaPendiente
                    ? hijosSeleccionados.find(h => h.id_matricula === hijo.id_matricula)
                        ? 'bg-blue-50 border-blue-200 shadow-sm'
                        : 'bg-white border-gray-200 hover:border-blue-200'
                    : 'bg-gray-50 border-gray-200 cursor-not-allowed opacity-60'
                }
            `}
                        >
                            <div className="flex items-center justify-between">
                                <div className="flex-1">
                                    <h3 className="text-xs sm:text-sm font-medium text-gray-900">{hijo.nombre}</h3>
                                    <p className="text-xs text-gray-500">Matrícula #{hijo.id_matricula}</p>
                                    
                                    {/* Estado del pago */}
                    {!hijo.requierePago && !hijo.pagoTarjetaPendiente && !hijo.transferenciaPendiente && (
                        <p className="text-xs sm:text-sm text-green-600 mt-2">Al día con los pagos</p>
                    )}
                    {hijo.pagoTarjetaPendiente && (
                        <p className="text-xs sm:text-sm text-orange-600 mt-2">Pago por tarjeta pendiente</p>
                    )}
                    {hijo.transferenciaPendiente && (
                        <p className="text-xs sm:text-sm text-yellow-600 mt-2">Transferencia en revisión</p>
                    )}
                    {hijo.requierePago && !hijo.pagoTarjetaPendiente && !hijo.transferenciaPendiente && (
                        <p className="text-xs sm:text-sm text-red-600 mt-2">Requiere pago</p>
                    )}
                                    
                                    {/* Mostrar monto si requiere pago */}
                                    {hijo.requierePago && hijo.precio && (
                                        <p className="text-xs text-blue-600 font-medium mt-1">
                                            Monto: ${parseFloat(hijo.precio).toFixed(2)}
                                        </p>
                                    )}
                                </div>
                                {hijosSeleccionados.find(h => h.id_matricula === hijo.id_matricula) && (
                                    <Check className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-blue-500" />
                                )}
                            </div>
                        </div>
                    )) : (
                        <div className="col-span-full p-8 text-center text-gray-500">
                            <p>No hay hijos disponibles para realizar pagos.</p>
                        </div>
                    )}
                </div>

                {/* Modal de Selección de Plan */}
                {mostrarSeleccionPlan && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                            <div className="p-6 border-b border-gray-200">
                                <div className="flex items-center justify-between">
                                    <h2 className="text-2xl font-bold text-gray-900">Seleccionar Plan</h2>
                                    <button
                                        onClick={() => setMostrarSeleccionPlan(false)}
                                        className="text-gray-400 hover:text-gray-600 transition-colors"
                                    >
                                        <ArrowLeft className="w-6 h-6" />
                                    </button>
                                </div>
                                {planActual && (
                                    <p className="text-sm text-gray-600 mt-2">
                                        Plan actual: <span className="font-semibold text-blue-600">{planActual.nombre}</span>
                                    </p>
                                )}
                            </div>

                            <div className="p-6">
                                {loadingPlanes ? (
                                    <div className="flex items-center justify-center py-12">
                                        <Loader className="w-8 h-8 animate-spin text-blue-600" />
                                        <span className="ml-3 text-gray-600">Cargando planes...</span>
                                    </div>
                                ) : (
                                    <div className="space-y-4">
                                        {planes && planes.length > 0 ? planes.map((plan) => (
                                            <div
                                                key={plan.id}
                                                onClick={(e) => handleSeleccionarPlan(plan, e)}
                                                className={`p-4 border-2 rounded-xl cursor-pointer transition-all duration-200 ${
                                                    planSeleccionado?.id === plan.id
                                                        ? 'border-blue-500 bg-blue-50'
                                                        : 'border-gray-200 hover:border-blue-300 hover:bg-gray-50'
                                                }`}
                                            >
                                                <div className="flex items-center justify-between">
                                                    <div className="flex-1">
                                                        <div className="flex items-center gap-3">
                                                            <h3 className="text-lg font-semibold text-gray-900">
                                                                {plan.nombre}
                                                            </h3>
                                                            {planActual?.id === plan.id && (
                                                                <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full">
                                                                    Actual
                                                                </span>
                                                            )}
                                                            {planSeleccionado?.id === plan.id && (
                                                                <CheckCircle className="w-5 h-5 text-blue-600" />
                                                            )}
                                                        </div>
                                                        <p className="text-sm text-gray-600 mt-1">
                                                            ${plan.monto} USD - {plan.tiempo}
                                                        </p>
                                                        {plan.descripcion && (
                                                            <p className="text-xs text-gray-500 mt-2">
                                                                {plan.descripcion}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )) : (
                                            <div className="p-4 text-center text-gray-500">
                                                No hay planes disponibles en este momento.
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className="p-6 border-t border-gray-200 flex gap-3">
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        cancelarSeleccionPlan(e);
                                    }}
                                    className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors font-medium"
                                >
                                    Cancelar
                                </button>
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        confirmarCambioPlan(e);
                                    }}
                                    disabled={!planSeleccionado || loadingPlanes}
                                    className="flex-1 px-4 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-medium flex items-center justify-center gap-2"
                                >
                                    {planActual?.id === planSeleccionado?.id ? (
                                        <>
                                            <RefreshCw className="w-4 h-4" />
                                            Renovar Plan
                                        </>
                                    ) : (
                                        <>
                                            <CheckCircle className="w-4 h-4" />
                                            Cambiar Plan
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {hijosSeleccionados.length > 0 && (
                    <div className="backdrop-blur-md bg-white/30 rounded-lg sm:rounded-2xl shadow-xl border border-white/50 p-3 sm:p-6">
                        <div className="mb-4 sm:mb-6 text-center">
                            <div className="text-xl sm:text-3xl font-bold text-gray-900 mb-2">
                                ${totalAmount.toFixed(2)} <span className="text-sm sm:text-base font-normal text-gray-500">USD total</span>
                            </div>
                            <div className="text-xs sm:text-sm text-gray-600">
                                {hijosSeleccionados.length} {hijosSeleccionados.length === 1 ? 'hijo seleccionado' : 'hijos seleccionados'}
                            </div>
                            {/* Mostrar detalle de montos individuales */}
                            <div className="text-xs text-gray-500 mt-1">
                                {hijosSeleccionados.map((hijo, index) => (
                                    <span key={hijo.id_matricula}>
                                        ${Number(hijo.plan_monto || 0).toFixed(2)} x {hijo.nombre}
                                        {index < hijosSeleccionados.length - 1 ? ' + ' : ''}
                                    </span>
                                ))}
                            </div>
                        </div>

                        {/* Mostrar pagos pendientes si existen */}
                        {pagoTarjetaPendiente && linkPago && (
                            <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-xl">
                                <div className="flex items-center gap-2 mb-3">
                                    <AlertCircle className="w-5 h-5 text-yellow-600" />
                                    <h3 className="font-semibold text-yellow-800">Pago Pendiente Detectado</h3>
                                </div>
                                <p className="text-yellow-700 text-sm mb-3">
                                    Tienes un pago con tarjeta pendiente. Estado: <span className="font-medium">{estadoPagoTarjeta}</span>
                                </p>
                                <div className="flex flex-col sm:flex-row gap-2">
                                    <a
                                        href={linkPago}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
                                    >
                                        <ExternalLink className="w-4 h-4" />
                                        Acceder al Pago
                                    </a>
                                    <button
                                        onClick={verificarEstadoPagoTarjeta}
                                        disabled={isVerificandoPago}
                                        className="flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 transition-colors text-sm"
                                    >
                                        <RefreshCw className={`w-4 h-4 ${isVerificandoPago ? 'animate-spin' : ''}`} />
                                        {isVerificandoPago ? 'Verificando...' : 'Verificar Estado'}
                                    </button>
                                </div>
                            </div>
                        )}

                        <form onSubmit={handleDLocalGoPagoMultiple} className="space-y-4 sm:space-y-6">
                            <div className="space-y-2 sm:space-y-4">
                                <label className="flex items-center gap-2 text-xs sm:text-sm font-medium text-gray-700">
                                    <FileText className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                                    Descripción (opcional)
                                </label>
                                <input
                                    type="text"
                                    placeholder="Agregar una nota a este pago"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white/50 border border-gray-200 rounded-lg sm:rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-xs sm:text-sm"
                                />
                            </div>

                            {/* Resumen del pago múltiple */}
                            {hijosSeleccionados.length > 0 && (
                                <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl">
                                    <h3 className="text-sm font-medium text-gray-800 mb-3">Resumen del Pago Múltiple</h3>
                                    <div className="space-y-2">
                                        {hijosSeleccionados.map((hijo) => (
                                            <div key={hijo.id_matricula} className="flex justify-between items-center text-xs">
                                                <span className="text-gray-600">{hijo.nombre}</span>
                                                <span className="font-medium text-gray-800">
                                                    ${hijo.plan_monto ? parseFloat(hijo.plan_monto).toFixed(2) : '0.00'}
                                                </span>
                                            </div>
                                        ))}
                                        <div className="border-t border-gray-300 pt-2 mt-2">
                                            <div className="flex justify-between items-center text-sm font-semibold">
                                                <span className="text-gray-800">Total a Pagar:</span>
                                                <span className="text-blue-600">
                                                    ${hijosSeleccionados.reduce((total, hijo) => 
                                                        total + (hijo.plan_monto ? parseFloat(hijo.plan_monto) : 0), 0
                                                    ).toFixed(2)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="space-y-2 sm:space-y-4">
                                <div className="p-4 bg-blue-50 border border-blue-200 rounded-xl">
                                    <div className="flex items-center gap-2 mb-2">
                                        <CreditCard className="w-4 h-4 text-blue-600" />
                                        <span className="text-sm font-medium text-blue-800">Pago Múltiple con dLocal Go</span>
                                    </div>
                                    <p className="text-xs text-blue-700">
                                        Al proceder, se creará un solo pago que cubrirá todas las mensualidades seleccionadas.
                                        Una vez verificado el pago, se aplicará automáticamente a todos los hijos seleccionados.
                                    </p>
                                </div>
                            </div>

                            {error && (
                                <div className="bg-red-50/50 border border-red-100 text-red-600 p-3 sm:p-4 rounded-lg sm:rounded-xl flex items-center gap-2 text-xs sm:text-sm">
                                    <Shield className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                                    {error}
                                </div>
                            )}

                            <button
                                type="submit"
                                disabled={isProcessingDLocal || hijosSeleccionados.length === 0}
                                className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-2.5 sm:py-4 px-4 sm:px-6 rounded-lg sm:rounded-xl hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 flex items-center justify-center gap-2 text-xs sm:text-sm font-medium"
                            >
                                <Lock className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                                {isProcessingDLocal ? "Procesando pagos..." : `Proceder al Pago $${totalAmount.toFixed(2)} USD`}
                            </button>
                        </form>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PagoMultiple;